// Mock data for Assetree Real Estate Website

export const heroData = {
  headline: "Strategic Real Estate Partner for Residential Success",
  subheadline: "Rooted in Real Estate Excellence - Assetree is a strategic real estate partner that works with residential developers to position, market, and sell apartment projects.",
  images: [
    "https://images.unsplash.com/photo-1580041065738-e72023775cdc",
    "https://images.unsplash.com/photo-1686056040370-b5e5c06c4273",
    "https://images.unsplash.com/photo-1574848296471-28f79a036f79"
  ]
};

export const aboutData = {
  title: "About Assetree",
  description: "Assetree is a professional real estate advisory and partnership firm supporting residential apartment projects across planning, positioning, and sales. We work closely with developers as long-term partners, helping projects reach the right audience with clarity, credibility, and market alignment.",
  subdescription: "Our focus is on quality-led residential developments, transparent communication, and sustainable value creation.",
  highlights: [
    "Strategic partnership with developers",
    "Transparent communication and processes",
    "Market positioning and advisory excellence",
    "Long-term value creation for all stakeholders"
  ]
};

export const projects = [
  {
    id: 1,
    name: "Fortune Primero",
    codename: "",
    tagline: "Urban Sanctuary | Where SOHO Life Reaches New Heights",
    description: "Fortune Primero is a 15-acre urban sanctuary in Bengaluru's thriving Sarjapur corridor, where Assetree supports strategic positioning and sales excellence. Four iconic towers (G+41 floors) soar as one of the region's tallest residential landmarks, offering 779 exclusive residences designed for those who refuse to compromise on privacy or space.",
    location: "Sarjapur Corridor, Bengaluru",
    scale: "15 Acres | 4 Towers | 779 Residences",
    structure: "G+41 Floors (Region's Tallest)",
    unitTypes: ["3 BHK", "4 BHK Corner Homes"],
    keyHighlights: [
      "15-acre urban sanctuary with 4 iconic towers",
      "G+41 floors - Region's tallest residential landmark",
      "779 exclusive residences with no common walls",
      "Only 4 corner homes per floor with private corridors",
      "6 uniquely themed sky bridges connecting towers",
      "11 acres residential + 4 acres integrated commercial hub",
      "100+ world-class amenities",
      "45,000 sq. ft. grand clubhouse"
    ],
    amenities: [
      "45,000 sq. ft. Grand Clubhouse",
      "17,000 sq. ft. Rooftop Terrace",
      "6 Themed Sky Bridges (World Cities)",
      "100+ World-Class Amenities",
      "Infinity Swimming Pool",
      "State-of-the-art Fitness Center",
      "Integrated Commercial & Retail Hub",
      "Private Corridor for Each Home",
      "No Common Walls - Villa in Sky",
      "Landscaped Gardens",
      "Sports & Recreation Zones",
      "24/7 Concierge Service"
    ],
    connectivity: [
      { location: "SHIFT City", time: "Adjacent" },
      { location: "Sarjapura Metro", time: "Upcoming" },
      { location: "Hosur Airport", time: "Upcoming" },
      { location: "Electronic City", time: "15-20 mins" }
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_rooted-real-estate/artifacts/qajn451n_gemini-2.5-flash-image_Ultra-realistic_architectural_hero_render_of_two_wide_luxury_residential_towers_-0%20%281%29.jpg",
      "https://images.unsplash.com/photo-1738168279272-c08d6dd22002?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBhcGFydG1lbnQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzEwNjQzNDd8MA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc3MTA2NDM1MXww&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1631679706909-1844bbd07221?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc3MTA2NDM1MXww&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1638454668466-e8dbd5462f20?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBhcGFydG1lbnQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzEwNjQzNDd8MA&ixlib=rb-4.1.0&q=85"
    ],
    status: "Ready to Move"
  },
  {
    id: 2,
    name: "Sobha Codename Trinity",
    codename: "TRINITY",
    tagline: "300 Acre Township | Redefining East Bangalore",
    description: "Sobha Codename Trinity is a landmark 300+ acre integrated township supported by Assetree through real estate advisory, branding guidance, and sales enablement. This mega development is set to redefine East Bangalore real estate with 6000+ units across phased development.",
    location: "Huskur Kodi, Hoskote (Near Old Madras Road)",
    launchDate: "April 2026",
    scale: "300+ Acres | 6000+ Units (Phased)",
    unitTypes: ["1 BHK", "2 BHK", "3 BHK", "4 BHK"],
    keyHighlights: [
      "300+ acres integrated township",
      "6000+ units across phased development",
      "Large lake buffer with 360° green zones",
      "20+ residential wings in master plan",
      "Multiple clubhouses and sports zones",
      "Central park with massive landscape lawns",
      "Commercial & retail high street planned",
      "Township loop road with internal feeders"
    ],
    amenities: [
      "Multiple Mega Clubhouses",
      "Sports Complexes & Courts",
      "Central Landscape Park",
      "Lake Buffer & Green Zones",
      "Commercial High Street",
      "Swimming Pools & Fitness Centers",
      "Kids Play Areas & Schools",
      "Retail & Dining Options",
      "Jogging & Cycling Tracks",
      "Community Centers",
      "EV Charging Stations",
      "24/7 Security & Surveillance"
    ],
    connectivity: [
      { location: "KR Puram", time: "20 mins" },
      { location: "Whitefield", time: "25-30 mins" },
      { location: "Airport STRR", time: "15-20 mins" },
      { location: "Hoskote Junction", time: "10 mins" }
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_rooted-real-estate/artifacts/gvx7x05v_gemini-2.5-flash-image_Luxury_residential_skyline_with_multiple_high-rise_towers_dramatic_orange_and_pi-0%20%281%29.jpg",
      "https://images.unsplash.com/photo-1638454668466-e8dbd5462f20?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBhcGFydG1lbnQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzEwNTY3NTZ8MA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1738168279272-c08d6dd22002?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBhcGFydG1lbnQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzEwNTY3NTZ8MA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc3MTA1Njc2MHww&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1631679706909-1844bbd07221?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc3MTA1Njc2MHww&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1693479197140-7ff18b73df0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHx0b3duc2hpcCUyMG91dGRvb3IlMjBhbWVuaXRpZXN8ZW58MHx8fHwxNzcxMDU2Nzg3fDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1638719192778-0d063146cb0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHx0b3duc2hpcCUyMG91dGRvb3IlMjBhbWVuaXRpZXN8ZW58MHx8fHwxNzcxMDU2Nzg3fDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1770064319714-8c4651102262?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxyZXNpZGVudGlhbCUyMHNwb3J0cyUyMGZhY2lsaXRpZXN8ZW58MHx8fHwxNzcxMDU2NzkxfDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1764254810952-aa9dad88be4e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxyZXNpZGVudGlhbCUyMHNwb3J0cyUyMGZhY2lsaXRpZXN8ZW58MHx8fHwxNzcxMDU2NzkxfDA&ixlib=rb-4.1.0&q=85"
    ],
    status: "Launching April 2026"
  }
];

export const whyChooseData = [
  {
    icon: "award",
    title: "Strategic Partnership",
    description: "Long-term collaboration with developers for project success"
  },
  {
    icon: "compass",
    title: "Market Positioning",
    description: "Expert advisory on positioning projects for the right audience"
  },
  {
    icon: "users",
    title: "Professional Advisory",
    description: "Comprehensive support across planning, branding, and sales"
  },
  {
    icon: "shield-check",
    title: "Transparent Processes",
    description: "Clear communication with developers and homebuyers"
  },
  {
    icon: "trending-up",
    title: "Sales Excellence",
    description: "Structured sales processes and lead generation expertise"
  },
  {
    icon: "home",
    title: "Sustainable Value",
    description: "Focus on quality-led developments with long-term appeal"
  }
];

export const lifestyleData = {
  title: "More Than a Home. A Lifestyle.",
  description: "At Assetree, we partner with developers who believe a home is where life unfolds. The projects we support are designed to nurture connections, inspire joy, and provide a sanctuary for families and individuals.",
  images: [
    "https://images.unsplash.com/photo-1767082090901-9a714d3c30e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBmYW1pbHklMjBob21lfGVufDB8fHx8MTc3MDM2NDQzNnww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1766808984121-6df21367b394?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBmYW1pbHklMjBob21lfGVufDB8fHx8MTc3MDM2NDQzNnww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1688699677407-c6864965f814?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxjb21tdW5pdHklMjBsaXZpbmd8ZW58MHx8fHwxNzcwMzY0NDQ1fDA&ixlib=rb-4.1.0&q=85"
  ]
};

export const faqData = [
  {
    question: "Is Assetree a real estate developer?",
    answer: "No. Assetree is not a developer. We work as a strategic partner with developers to support residential apartment projects through advisory, positioning, and sales execution."
  },
  {
    question: "What does Assetree do for developers?",
    answer: "Assetree helps developers with market strategy, project positioning, branding, lead generation, sales processes, and customer experience."
  },
  {
    question: "Does Assetree sell apartments directly?",
    answer: "Assetree supports the sales process in collaboration with developers, ensuring structured communication and transparent buyer engagement."
  },
  {
    question: "Who should work with Assetree?",
    answer: "Residential developers, investors, and homebuyers looking for well-positioned apartment projects backed by professional advisory support."
  }
];

export const contactData = {
  email: "assetreeteam@gmail.com",
  phone: "+91 6360268680",
  address: "827, Ramamurthi Nagar Main Rd, Muninanjappa Layout, Ramamurthy Nagar, Bengaluru, Karnataka 560016",
  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.4!2d77.6686!3d13.0127!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae17!2sRamamurthy%20Nagar%2C%20Bengaluru!5e0!3m2!1sen!2sin!4v1234567890"
};
